var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.videoSrc)?_c('div',{staticStyle:{"position":"fixed","top":"0","bottom":"0","right":"0","left":"0","z-index":"999","background-color":"#000"}},[_c('video',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"videoEle","src":_vm.videoSrc,"autoplay":"true","controls":""},on:{"ended":_vm.videoEnded}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7976c088","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/videoPlay.vue
// module id = null
// module chunks = 